import { IdentityUserAri, PlatformSiteAri } from '@atlassian/ari';
import { EntryPointRef } from '@atlassian/entry-point-types';
import { homeAssignedListEntryPoint } from '@atlassian/home-assigned/entrypoint';
import { loadEntryPoint } from 'react-relay';

import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import { createResource } from '@townsquare/router/resources/createResource';
import type { RouteResource } from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';
import { expVal } from '@townsquare/stat-sig';

type AssignedData = EntryPointRef<typeof homeAssignedListEntryPoint>;

export const assignedResource: RouteResource<AssignedData | undefined> = createResource<
	AssignedData | undefined
>({
	type: 'ASSIGNED',
	// Key is static for now - this may change if we introduce product filters to assigned
	getKey: () => 'assigned-resource',
	getData: async (_routerContext, resourceContext) => {
		if (!expVal('townsquare_assigned_list', 'isEnabled', false)) {
			return;
		}

		const { user, collabContext } = resourceContext as ResourceContext;
		const cloudId = collabContext?.rovoWorkspace;

		if (!user?.accountId || !cloudId) {
			return;
		}

		try {
			return loadEntryPoint(
				{ getEnvironment: getAggRelayEnvironment },
				homeAssignedListEntryPoint,
				{
					currentUser: IdentityUserAri.create({ userId: user.accountId }),
					unitId: PlatformSiteAri.create({ siteId: cloudId }),
				},
			);
		} catch {
			return;
		}
	},
});
